import { PENSION_ANNUITY_WAITING_YEARS } from "./CalculatorLimits";

type Params = {
	monthlyAnnuity: number;
	annuityYears: number;
	yearsUntilAnnuity: number;
	initialDeposit: number;
	interestRate: number;
};

export const getPensionAnnuityPlan = ({
	monthlyAnnuity,
	annuityYears,
	yearsUntilAnnuity,
	initialDeposit,
	interestRate,
}: Params) => {
	const rate = interestRate / 100;
	const monthlyFactor = (1 + rate) ** (1 / 12);
	const requiredAmount =
		(monthlyAnnuity * (1 - (1 + rate) ** -annuityYears)) / (monthlyFactor - 1);

	const instalment = (years: number) => {
		if (years <= 0) {
			return 0;
		}

		const remains = requiredAmount - initialDeposit * (1 + rate) ** years;
		const value =
			remains /
			monthlyFactor /
			((monthlyFactor ** (years * 12) - 1) / (monthlyFactor - 1));

		return value < 0 ? 0 : Math.round(value);
	};

	return {
		monthlyPayment: instalment(yearsUntilAnnuity),
		requiredAmount: Math.round(requiredAmount),
		monthlyPaymentLater: instalment(
			yearsUntilAnnuity - PENSION_ANNUITY_WAITING_YEARS,
		),
		waitingYears: PENSION_ANNUITY_WAITING_YEARS,
	};
};
